import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Globe03 = function Globe03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2c3 2 3.9228 6.292 4 10-.0772 3.708-1 8-4 10m0-20C9 4 8.0772 8.292 8 12c.0772 3.708 1 8 4 10m0-20C6.4772 2 2 6.4772 2 12M12 2c5.5228 0 10 4.4772 10 10M12 22c5.5229 0 10-4.4772 10-10M12 22C6.4772 22 2 17.5228 2 12m20 0c-2 3-6.292 3.9228-10 4-3.708-.0772-8-1-10-4m20 0c-2-3-6.292-3.9228-10-4-3.708.0772-8 1-10 4"
    })
  }));
};
export default Globe03;